import HorizontalNavList from "../../../../src/components/horizontal-nav-list.js";
import React from 'react';
export default {
  HorizontalNavList,
  React
};